// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".half-star[data-v-9ecb51c6]{font-size:20px;background:linear-gradient(90deg,orange 0,orange 50%,#d3d3d3 0,#d3d3d3);-webkit-background-clip:text;-webkit-text-fill-color:transparent}.full-star[data-v-9ecb51c6]{font-size:20px;color:orange}.empty-star[data-v-9ecb51c6]{font-size:20px;color:#d3d3d3}.rating-container[data-v-9ecb51c6]{margin:2px;display:inline-block}", ""]);
// Exports
module.exports = exports;
